var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsOptional, IsString, IsUUID } from 'class-validator';
export class OfficeLocationBillingDetailsResponseDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    taxNumber;
    vatId;
    iban;
    bic;
    bankName;
    invoiceFooter;
    invoiceEmailSender;
    isSmallBusiness;
    /**
     * Numbering configuration + per-field lock state. Locks are computed on
     * read from the office's `pt_invoice_number_sequence` rows.
     */
    numbering;
    /**
     * Mahnwesen configuration — per-stage Mahngebühren + minimum days between
     * stages. `null` on any field means "use the system default".
     */
    mahnwesen;
    /**
     * Cancellation-fee policy (TM-9064). `null` means the practice levies no
     * fee; otherwise the configured policy that will be snapshotted onto new
     * `AgreementData` rows. Existing in-flight plans keep their own snapshot.
     */
    cancellationFeePolicy;
    /**
     * The §302 Absender-IK of this Standort (TM-9538 / #1518) — who its
     * Nutzdatendateien go out under.
     *
     * `null` means "fall back to the deployment-level Abrechnungsstellen-IK".
     * ⚠ **This field does not say whether that fallback exists**, and deliberately
     * so: `resolveAbsender` is the only reader of either source, and a settings
     * screen that peeked at the environment would be a second one. A practice with
     * neither configured learns it from the Abrechnungslauf, which refuses before
     * it takes the in-flight lock and names both places in the message.
     */
    absenderIk;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationBillingDetailsResponseDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationBillingDetailsResponseDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], OfficeLocationBillingDetailsResponseDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], OfficeLocationBillingDetailsResponseDto.prototype, "officeLocationId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "taxNumber", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "vatId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "iban", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "bic", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "bankName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "invoiceFooter", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "invoiceEmailSender", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], OfficeLocationBillingDetailsResponseDto.prototype, "isSmallBusiness", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "numbering", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "mahnwesen", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "cancellationFeePolicy", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], OfficeLocationBillingDetailsResponseDto.prototype, "absenderIk", void 0);
//# sourceMappingURL=office-location-billing-details.response.dto.js.map